import * as React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'tabler-react';
import toast from 'cogo-toast';
import Request from '../../shared/request';
import AlipaySvg from '../../assets/ic_alipay.svg';
import PaypalSvg from '../../assets/ic_paypal.svg';

class Withdrowal extends React.Component {
  state = {
    paytype: 'paypal',
    account: '',
    idname: '',
  };

  constructor(props) {
    super(props);
    const { idname, account, paytype } = this.props.affWithdrawAccount || {};
    if (idname) {
      this.state.idname = idname;
    }
    if (account) {
      this.state.account = account;
      this.state.exists = true;
    }
    if (paytype) {
      this.state.paytype = paytype;
    }
  }

  handleWithdrowal = async () => {
    if (!['paypal', 'alipay'].includes(this.state.paytype)) {
      toast.warn('暂不支持该支付方式');
      return;
    }
    if (!this.state.account) {
      toast.warn(
        `请提供${this.state.paytype === 'paypal' ? 'paypal' : '支付宝'}账号`,
      );
      return;
    }
    if (!this.state.idname) {
      toast.warn('请填写真实姓名');
      return;
    }
    const res = await Request.call('saveWithdrawAffAccount', {
      paytype: this.state.paytype,
      account: this.state.account,
      idname: this.state.idname,
    });
    if (res && res.paytype) {
      toast.success('设置完成');
    }
    const modalEl = document.getElementById('modal');
    const rootEl = document.getElementById('root');
    if (modalEl) {
      rootEl.removeChild(modalEl);
    }
    this.props.refreshAmount();
  };

  render() {
    return (
      <div className="withdrowal-setting">
        <div className="account-info">
          <h4>提现账号</h4>
          <div className="payment-type">
            <div
              onClick={() => this.setState({ paytype: 'paypal' })}
              className={`${this.state.paytype === 'paypal' ? 'active' : ''}`}>
              <img src={PaypalSvg} alt="paypal" />
              <span>Paypal</span>
            </div>
            <div
              onClick={() => this.setState({ paytype: 'alipay' })}
              className={`${this.state.paytype === 'alipay' ? 'active' : ''}`}>
              <img src={AlipaySvg} alt="alipay" />
              <span>支付宝</span>
            </div>
          </div>
          <div className="account">
            <div className="form-wrapper account-name">
              <div className="label">提现账号</div>
              <input
                type="text"
                placeholder={`请输入${
                  this.state.paytype === 'paypal' ? 'Paypal' : '支付宝'
                }账号`}
                value={this.state.account}
                onChange={e => this.setState({ account: e.target.value })}
              />
            </div>

            <div className="form-wrapper">
              <div className="label">姓名</div>
              <input
                type="text"
                value={this.state.idname}
                placeholder="真实姓名，用于转账验证"
                onChange={e => this.setState({ idname: e.target.value })}
              />
            </div>
          </div>
        </div>
        <div className="desc">
          <h4>自动提现说明:</h4>
          <li>1. 每个月15号前，自动发放上个月返现金额</li>
          <li>
            2. 提现扣除 5% 左右的手续费，具体以到账金额为准 |
            金额大于$20才能满足发放资格
          </li>
          <Button onClick={this.handleWithdrowal} pill color="primary">
            {this.state.exists ? '更新提现设置' : '开启自动提现'}
          </Button>
        </div>
      </div>
    );
  }
}

Withdrowal.propTypes = {
  affWithdrawAccount: PropTypes.object,
  refreshAmount: PropTypes.func,
};

export default Withdrowal;
